/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/destructuring-assignment */
import { Group, Space } from '@mantine/core';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import PageSection from '../../../../../../components/core/PageSection/PageSection';
import ProfileCardLink from '../../../../../../components/core/ProfileCardLink/ProfileCardLink';
import TableCellEllipsis from '../../../../../../components/core/TableCellEllipsis/TableCellEllipsis';
import { EntityServiceType } from '../../../../../../models/core/entities.type';
import { Feature } from '../../../../../../utils/constants.utils';
import { formatTimestampToString } from '../../../../../../utils/formatter.utils';

type ViewProps = {
  data: EntityServiceType[];
};

export default function ServiceView(props: ViewProps) {
  const columns: ColumnsType<any> = [
    {
      title: 'Serviço',
      key: 'servico',
      dataIndex: 'servico',
      sorter: (a: EntityServiceType, b: EntityServiceType) => a.servico.localeCompare(b.servico),
    },
    {
      title: 'Descrição',
      key: 'ServicoDescricao',
      sorter: (a: EntityServiceType, b: EntityServiceType) =>
        (a.servicoDescricao || '').localeCompare(b.servicoDescricao || ''),
      render: (row: EntityServiceType) => (
        <TableCellEllipsis label={row?.servicoDescricao} numberOfChars={25} toolTipWidth={300} />
      ),
    },
    {
      title: 'Criado Por',
      key: 'criadoPor',
      sorter: (a: EntityServiceType, b: EntityServiceType) => a.criadoPor.localeCompare(b.criadoPor),
      render: (row: EntityServiceType) => (
        <ProfileCardLink id={row.idCriadoPor} name={row.criadoPor} nameSize="sm" />
      ),
    },
    {
      title: 'Data Criação',
      key: 'dataCriacao',
      sorter: (a: EntityServiceType, b: EntityServiceType) => {
        const aValue = a.dataCriacao.valueOf();
        const bValue = b.dataCriacao.valueOf();
        if (aValue === bValue) {
          return 0;
        }
        return aValue > bValue ? 1 : -1;
      },
      render: (row: EntityServiceType) => formatTimestampToString(row.dataCriacao),
    },
  ];

  return (
    <div>
      <Group>
        <PageSection size="lg" color={Feature.Reference.Entity.color} label="Serviços" text="" />
      </Group>
      <Space h="xs" />
      <Table
        showSorterTooltip={false}
        // size="small"
        dataSource={props.data}
        columns={columns}
        rowKey={(item: EntityServiceType) => item.idEntidadeServico || 0}
        pagination={{
          pageSizeOptions: [10, 25, 50],
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
        }}
      />
    </div>
  );
}
